import { createSlice } from '@reduxjs/toolkit';

interface CommonState {
    collapsed: boolean;
}

const initialState: CommonState = {
    collapsed: false,
};

const commonSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    setIsCollapsed(state, action) {
      state.collapsed = action.payload;
    },
    
  }
});

export const { setIsCollapsed } = commonSlice.actions;

export default commonSlice.reducer;
